import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'

import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";

import {
	BasicSelect
} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);

export default {
	name: 'order',
	components: {
		Paginate,
		Pagination,
		JsonExcel,
		DatePicker,
		Loader,
		BasicSelect
	},
	data() {
		return {
			// currentPage: 0,
			mid: '',
			isLoadingforxls: false,
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			listOrderReportData: {
				ordercount: 0,
				totalsku: 0,
				totalquantity: 0,
				result: [],
			},
			ponoFlt: "",
			fromDateFlt: '',
			fromDateFltShip: "",
			toDateFltShip: "",
			// perPage: 10,
			// totalPage: 0,
			// pageNo: 0,
			orderStatus: '',
			isLoading: false,
			listClientData: [],
			listWarehouseData: [],
			totalrowsData: [],
			listOrderReportDataCsv: [],
			swarehouse : localStorage.getItem("selectedWarehouse"),
			ClientErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,

			clientid: '',
			client: '',
			warehouseid: '',
			warehouse: '',

			//checkStatus: 0,
			searchchannel: '',


			channellist: [],
			showOrderAllocationRacks: false,
			allocationResultData: [],
			formattedDate: '',
			ordertype: '',
			ordersubtype: '',
			user_type: '',
			userid: '',
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			recordLimit: 0,
			limitExeed: false,
			listMerchantData: [],
			merchant: '',
			toDateFlt: '',
			currentDate: '',
			item: {
				value: '',
				text: ''
			},
			listMerchantData1: [{
				value: '',
				text: this.$t('common.selectMerchantPlaceHolder')
			}],

			// totalRows:0,
			searchzone:'',
			listZoneData:[],
			searchpickerid: '',
			pickerListData: '',

		}
	},
	model: {
		totalqty: 0
	},
	computed: {},
	filters: {

		moment: function (date) {
			if (date != null)
				return moment(date).format('DD-MM-YYYY');
		},
		momentDateTime: function (date) {
			if (date != null)
				return moment(date).format('DD/MM/YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		var loginuseremail = userdetail.email;
		this.userid = userdetail.userid;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname = this.$t('common.order')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.pageNo = 0;
		this.orderStatus = 'allocated'

		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getMerchantList();
		this.getSalesChannels();
		}
		if (localStorage.getItem("selectedWarehouse")!=='undefined')
		{
			this.getPickersList();
			this.getRacksZonesList()
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// ?this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getWarehouseList();
				this.getMerchantList();
				if (userdetail.merchantid) {
					this.mid = userdetail.merchantid.toString()
					this.merchant = this.mid
					this.showSelectMerchant = false;
				}
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				this.getPickersList();
				this.getRacksZonesList()



				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit();
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			// console.log(newValue+"===============in event")
			// Perform any other actions needed
			this.getPickersList();
			this.getRacksZonesList();
		  });
		//this.calldateFunction();
	},// End computed
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {
			// select option from parent component
			this.item = item
			this.merchant = item.value;

		},
		calldateFunction() {
			//console.log("sagar")
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');

			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.toDateFlt = this.currentDate;
			this.fromDateFlt = dt;

		},


		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantListArray = [];
						result.data.forEach(function (item) {
							merchantListArray[item.merchantid] = item.merchantname;
						});
						this.merchantList = merchantListArray;
						this.item = {
							value: '',
							text: ''
						},
							this.listMerchantData1 = [{
								value: '',
								text: this.$t('common.selectMerchantPlaceHolder')
							}]
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname

							})
						})

					}
				}, error => {
					console.error(error)
				})
		},


		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype1() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getOrderListReportXLS(3)
			}
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype2() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getOrderListReportXLS(3)
			}
		},
		Choosetype3() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getOrderListReportXLS(3)
			}
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('dDD/MM/YYYY HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},

		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		// getClientList() {
		// 	this.pageNo = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageNo = 0;

		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageNo = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.listMerchantData = [];
		// 		this.merchant = '';
		// 		this.getMerchantList();

		// 		if (this.clientid)
		// 			this.getSalesChannels();
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = [];
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = '';
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid) {
		// 				//this.getOrderListReport();
		// 				this.getPickersList();
		// 		        this.getRacksZonesList()
		// 			}
		// 		}
		// 	}
		// 	this.getMerchantList();
		// 	this.listOrderReportData = {
		// 		ordercount: 0,
		// 		totalsku: 0,
		// 		totalquantity: 0,
		// 		result: [],
		// 	};
		// 	this.pageNo = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageNo = this.totalPage = 0;
		// 	if (this.user_type == 'client_user') {
		// 		this.getMerchantList();
		// 		this.getRacksZonesList();
		// 		this.getPickersList()
		// 	}
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			this.getSalesChannels();
		// 			// console.log(this.warehouse);
		// 			// this.getOrderListReport();
		// 			this.getRacksZonesList();
		// 			this.getPickersList();
		// 		} else {
		// 			this.getClientList();
		// 			this.getRacksZonesList();
		// 			this.getPickersList();
		// 		}
		// 	}
		// },
		getPickersList() {

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				warehouseid: this.warehouseid,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getWarehousePickerList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.pickerListData = result.data.data.data;
				}, error => {
					console.error(error)
				})
		},
		async getRacksZonesList() {
			try {
				if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
					this.$alertify.error(this.$t('common.warehouseError'))
					return false
				}
				this.listZoneData = [];
				this.searchzone = '';
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '')
				if (this.warehouseid) {
					this.isLoading = true
					console.log("kkkkkkkllll");
					this.listZoneData = []
					this.isLoading = true
					var userToken = window.localStorage.getItem('userToken')
					var myStr = userToken.replace(/"/g, '')
					let result = await axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getZonesByWarehouse',
						'data': {
							warehouseid: localStorage.getItem("selectedWarehouse")
						},
						'headers': {
							'Authorization': 'Bearer ' + myStr
						}
					})
					this.listZoneData = result.data.data.data;
					this.isLoading = false
				}
			} catch (err) {
				console.log(err);
			}

		},

		viewRackDetails(orderid) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.showOrderAllocationRacks = true;
			this.isLoading = true;

			if (this.clientid == '') {
				this.ClientErr = this.$t('common.clientError');
				return false;
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getOrderAllocationRackDetails',
				'data': {
					clientid: this.clientid,
					orderid: orderid,
					warehouseid: this.warehouseid
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.allocationResultData = result.data.data;
					this.isLoading = false;
				}, error => {
					console.error(error);
				});
		},
		getSalesChannels() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (this.clientid == '') {
				this.ClientErr = this.$t('common.clientError');
				return false;
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'orderSalesChannelList',
				'data': {
					clientid: this.clientid
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.channellist = result.data.data;
				}, error => {
					console.error(error);
				});
		},
		getOrderListSearch(csvCheck) {
			this.currentPage = 1;
			this.getOrderListReport(2);
		},
		getOrderListReport(csvCheck = 0) {
			//console.log("ram")
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listOrderReportData = {
					ordercount: 0,
					totalsku: 0,
					totalquantity: 0,
					result: [],
				};

				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listOrderReportData = {
					ordercount: 0,
					totalsku: 0,
					totalquantity: 0,
					result: [],
				};
				console.log("here")
				return false;
			}
			// if (action == 1)
			//   this.pageNo = this.totalPage = 0;
			var fromdate = '';
			var todate = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};

			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = this.dateFormat(this.fromDateFlt) + " 00:00:00";
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = this.dateFormat(this.toDateFlt) + " 23:59:59";
			}

			if (this.fromDateFltShip != null && this.fromDateFltShip != "") {
				fromdateship = this.dateFormat(this.fromDateFltShip) + " 00:00:00";
			}
			if (this.toDateFltShip != null && this.toDateFltShip != "") {
				todateship = this.dateFormat(this.toDateFltShip) + " 23:59:59";
			}

			this.isLoading = true;

			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				orderStatus: this.orderStatus,
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: this.clientid,
				fromDateFlt: fromdate,
				toDateFlt: todate,
				fromDateFltShip: fromdateship,
				toDateFltShip: todateship,
				searchchannel: this.searchchannel,
				ordertype: this.ordertype,
				ordersubtype: this.ordersubtype,
				pono: this.ponoFlt.trim(),
				csvData: csvCheck,
				userid: this.userid,
				merchantid: this.merchant,
				zoneid:this.searchzone,
				pickerid: this.searchpickerid,

			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			console.log("sagar")
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'orderListPendingRecord',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.totalRows) {
							this.show = true;
							this.download = false;
							this.listOrderReportDataCsv = [];
							var skipFilter = [];
							if (this.orderStatus == 'allocated') {
								this.csvFields = {
									'poid':this.$t('orders.orderId'),
									'totalitem': this.$t('editedjson.totalItem'),
									'totalquantity':this.$t('common.totalQuantity'),
									'saleschannel': this.$t('common.salesChannel'),
									'orderdate': this.$t('orders.orderDate'),
									'ordertype': this.$t('boxList.orderType'),
									'ordersubtype': this.$t('orderreport.ordersubtype'),
									'creationdate':  this.$t('purchaseOrder.creationDate'),
									'pickuserid': this.$t('editedjson.pickUserId'),
									'userassigndate': this.$t('editedjson.userAssignDate'),
									'custmobile':  this.$t('editedjson.Custmobile'),
									'customerfirstname': this.$t('editedjson.customerFirstName'),
									'customerlastname': this.$t('editedjson.customerLastName'),
									'modifieddatetime': this.$t('editedjson.modifiedDatetime'),
									'modifyby': this.$t('orders.modifyBy'),
									'status': this.$t('client.status'),
									'shipbydate': this.$t('common.shipByDate'),
									'merchantname': this.$t('common.merchantName'),
									'eancode' : 'Eancode',
									'rackid' : 'RackId'
								};

							}
							if (this.orderStatus == 'ready') {
								this.csvFields = {
									'creationdate': this.$t('purchaseOrder.creationDate'),
									'createddatetime':  this.$t('common.createdDateTime'),
									'orderid':this.$t('orders.orderId'),
									'sku': this.$t('common.sku'),
									'totalquantity': this.$t('editedjson.totalItem'),
									'saleschannel': this.$t('common.salesChannel'),
									'lastmodifiedby': this.$t('common.lastModifiedBy'),
									'lastmodifieddate': this.$t('common.lastModifiedDate'),
									'ordertype': this.$t('boxList.orderType'),
									'ordersubtype': this.$t('editedjson.orderSubType'),
									'creationdate':this.$t('purchaseOrder.creationDate'),
									'boxid': this.$t('common.boxId'),
									'awbno': this.$t('common.awbNo'),
									'shippingcompany': this.$t('orders.shippingCompany'),
									'dateFormcreateddatetime':this.$t('editedjson.orderSubType'),
									'shipbydate': this.$t('common.shipByDate'),
									'merchantname': this.$t('common.merchantName'),

								};
								skipFilter = ['totalitem'];
							}
							if (this.orderStatus == 'picked') {
								this.csvFields = {
									'boxid': this.$t('common.boxId'),
									'orderid': this.$t('orders.orderId'),
									'creationdate': this.$t('purchaseOrder.creationDate'),
									'lastmodifiedby': this.$t('common.lastModifiedBy'),
									'lastmodifieddate': this.$t('common.lastModifiedDate'),
									'modifyby': this.$t('orders.modifyBy'),
									'ordertype': this.$t('boxList.orderType'),
									'ordersubtype':  this.$t('editedjson.orderSubType'),
									'poid':this.$t('editedjson.poId'),
									'pickdonedate': this.$t('editedjson.pickDoneDate'),
									'saleschannel': this.$t('common.salesChannel'),
									'totalitem': this.$t('common.sku'),
									'totalquantity': this.$t('common.totalQuantity'),
									'userassigndate':this.$t('editedjson.userAssignDate'),
									'shipbydate':this.$t('common.shipByDate'),
									'merchantname': this.$t('common.merchantName'),

								};
							}
							var dateFilter = ['creationdate', 'pickdonedate', 'lastmodifieddate', 'userassigndate', 'shipbydate', 'modifieddatetime', 'orderdate', 'dateFormcreateddatetime', 'createddatetime'];

							this.listOrderReportDataCsv = result.data.result;
							csvHelper.data.jsonToCSV(this.$t('common.order'), this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('order', this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							this.$alertify.success(this.$t('common.reportSizeError'));
						}
					} else {
						this.listOrderReportData = result.data;
						this.totalRows = result.data.totalRows;
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						if (this.totalRows == undefined) {
							this.totalRows = 0;
						}
						if (this.totalRows < this.pageLimit) {
							this.totalPage = 1;
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		getOrderListReportXLS(csvCheck = 0) {

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';

			var fromdate = '';
			var todate = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};

			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = this.dateFormat(this.fromDateFlt) + " 00:00:00";
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = this.dateFormat(this.toDateFlt) + " 23:59:59";
			}

			if (this.fromDateFltShip != null && this.fromDateFltShip != "") {
				fromdateship = this.dateFormat(this.fromDateFltShip) + " 00:00:00";
			}
			if (this.toDateFltShip != null && this.toDateFltShip != "") {
				todateship = this.dateFormat(this.toDateFltShip) + " 23:59:59";
			}


			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				orderStatus: this.orderStatus,
				warehouseid: this.warehouseid,
				clientid: this.clientid,
				fromDateFlt: fromdate,
				toDateFlt: todate,
				fromDateFltShip: fromdateship,
				toDateFltShip: todateship,
				searchchannel: this.searchchannel,
				ordertype: this.ordertype,
				ordersubtype: this.ordersubtype,
				pono: this.ponoFlt.trim(),
				csvData: csvCheck,
				userid: this.userid,
				merchantid: this.merchant,
				zoneid:this.searchzone,
				pickerid: this.searchpickerid,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'orderListPendingRecord',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.totalRows) {
							this.listReportDataforxls = [];
							var skipFilter = [];
							if (this.orderStatus == 'allocated') {
								this.csvFieldsForXls[this.$t('orders.orderId')]='poid',
								this.csvFieldsForXls[this.$t('editedjson.totalItem')]='totalitem',
								this.csvFieldsForXls[this.$t('common.totalQuantity')]='totalquantity',
								this.csvFieldsForXls[this.$t('common.eanCode')] = 'eancode',
                                this.csvFieldsForXls[this.$t('common.rackID')] = 'rackid',
								this.csvFieldsForXls[this.$t('common.salesChannel')]='saleschannel',
								this.csvFieldsForXls[this.$t('orders.orderDate')]='orderdate',
								this.csvFieldsForXls[this.$t('boxList.orderType')]='ordertype',
								this.csvFieldsForXls[this.$t('orderreport.ordersubtype')]='ordersubtype',
								this.csvFieldsForXls[this.$t('purchaseOrder.creationDate')]='creationdate',
								this.csvFieldsForXls[this.$t('editedjson.pickUserId')]='pickuserid',
								this.csvFieldsForXls[this.$t('editedjson.userAssignDate')]='userassigndate',
								this.csvFieldsForXls[this.$t('editedjson.Custmobile')]='custmobile',
								this.csvFieldsForXls[this.$t('editedjson.customerFirstName')]='customerfirstname',
								this.csvFieldsForXls[this.$t('editedjson.customerLastName')]='customerlastname',
								this.csvFieldsForXls[this.$t('editedjson.modifiedDatetime')]='modifieddatetime',
								this.csvFieldsForXls[this.$t('orders.modifyBy')]='modifyby',
								this.csvFieldsForXls[this.$t('client.status')]='status',
								this.csvFieldsForXls[this.$t('common.shipByDate')]='shipbydate',
								this.csvFieldsForXls[this.$t('common.merchantName')]='merchantname',
								this.csvFieldsForXls[this.$t('common.merchantName')]='merchantname',
								this.csvFieldsForXls[this.$t('common.merchantName')]='merchantname'
							}
							if (this.orderStatus == 'ready') {
								this.csvFieldsForXls[this.$t('orders.orderId')]='orderid',
								this.csvFieldsForXls[this.$t('purchaseOrder.creationDate')]='creationdate',
								this.csvFieldsForXls[this.$t('common.createdDateTime')]='createddatetime',
								this.csvFieldsForXls[this.$t('common.sku')]='totalitem',
								this.csvFieldsForXls[this.$t('editedjson.totalItem')]='totalquantity',
								this.csvFieldsForXls[this.$t('common.salesChannel')]='saleschannel',
								this.csvFieldsForXls[this.$t('common.lastModifiedBy')]='lastmodifiedby',
								this.csvFieldsForXls[this.$t('common.lastModifiedDate')]='lastmodifieddate',
								this.csvFieldsForXls[this.$t('boxList.orderType')]='ordertype',
								this.csvFieldsForXls[this.$t('editedjson.orderSubType')]='ordersubtype',
								this.csvFieldsForXls[this.$t('purchaseOrder.creationDate')]='creationdate',
								this.csvFieldsForXls[this.$t('common.boxId')]='boxid',
								this.csvFieldsForXls[this.$t('common.awbNo')]='awbno',
								this.csvFieldsForXls[this.$t('orders.shippingCompany')]='shippingcompany',
								this.csvFieldsForXls[this.$t('editedjson.dateFromCreatedDateTime')]='dateFormcreateddatetime',
								this.csvFieldsForXls[this.$t('common.shipByDate')]='shipbydate',
								this.csvFieldsForXls[this.$t('common.merchantName')]='merchantname'

								skipFilter = ['totalitem'];
							}
							if (this.orderStatus == 'picked') {
								this.csvFieldsForXls[this.$t('orders.orderId')]='orderid',
								this.csvFieldsForXls[this.$t('common.boxId')]='boxid',
								this.csvFieldsForXls[this.$t('purchaseOrder.creationDate')]='creationdate',
								this.csvFieldsForXls[this.$t('common.lastModifiedBy')]='lastmodifiedby',
								this.csvFieldsForXls[this.$t('common.lastModifiedDate')]='lastmodifieddate',
								this.csvFieldsForXls[this.$t('orders.modifyBy')]='modifyby',
								this.csvFieldsForXls[this.$t('boxList.orderType')]='ordertype',
								this.csvFieldsForXls[this.$t('editedjson.orderSubType')]='ordersubtype',
								this.csvFieldsForXls[this.$t('editedjson.pickDoneDate')]='pickdonedate',
								this.csvFieldsForXls[this.$t('editedjson.pickDoneDate')]='pickdonedate',
								this.csvFieldsForXls[this.$t('common.salesChannel')]='saleschannel',
								this.csvFieldsForXls[this.$t('common.sku')]='totalitem',
								this.csvFieldsForXls[this.$t('common.totalQuantity')]='totalquantity',
								this.csvFieldsForXls[this.$t('editedjson.userAssignDate')]='userassigndate',
								this.csvFieldsForXls[this.$t('common.shipByDate')]='shipbydate',
								this.csvFieldsForXls[this.$t('common.merchantName')]='merchantname'
							}
							this.listReportDataforxls = result.data.result;
							this.listReportDataforxls.forEach(function (entry) {
								if (entry.modifieddatetime != '' && entry.modifieddatetime != null) {
									entry.modifieddatetime = moment(entry.modifieddatetime).format('DD/MM/YYYY HH:mm:ss');

								}
								if (entry.createddatetime != '' && entry.createddatetime != null) {
									entry.createddatetime = moment(entry.createddatetime).format('DD/MM/YYYY HH:mm:ss');

								}
								if (entry.creationdate != '' && entry.creationdate != null) {
									entry.creationdate = moment(entry.creationdate).format('DD/MM/YYYY HH:mm:ss');

								}
								if (entry.pickdonedate != '' && entry.pickdonedate != null) {
									entry.pickdonedate = moment(entry.pickdonedate).format('DD/MM/YYYY HH:mm:ss');

								}
								if (entry.lastmodifieddate != '' && entry.lastmodifieddate != null) {
									entry.lastmodifieddate = moment(entry.lastmodifieddate).format('DD/MM/YYYY HH:mm:ss');

								}
								if (entry.userassigndate != '' && entry.userassigndate != null) {
									entry.userassigndate = moment(entry.userassigndate).format('DD/MM/YYYY HH:mm:ss');

								}
								if (entry.shipbydate != '' && entry.shipbydate != null) {
									entry.shipbydate = moment(entry.shipbydate).format('DD/MM/YYYY HH:mm:ss');

								}
								if (entry.orderdate != '' && entry.orderdate != null) {
									entry.orderdate = moment(entry.orderdate).format('DD/MM/YYYY HH:mm:ss');

								}
								if (entry.dateFormcreateddatetime != '' && entry.dateFormcreateddatetime != null) {
									entry.dateFormcreateddatetime = moment(entry.dateFormcreateddatetime).format('DD/MM/YYYY HH:mm:ss');


								}
								if (entry.dateFormcreateddatetime != '' && entry.dateFormcreateddatetime != null) {
									entry.dateFormcreateddatetime = moment(entry.dateFormcreateddatetime).format('DD/MM/YYYY HH:mm:ss');

								}

							});

							// this.jsonToCSV('order', this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							this.$alertify.success(this.$t('common.reportSizeError'));
						}


					}


				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.perPage
		// 	this.getOrderListReport()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getOrderListReport()
		},
		loadOrderReport(status) {
			this.listOrderReportData = {
				ordercount: 0,
				totalsku: 0,
				totalquantity: 0,
				result: [],
			};
			this.calldateFunction();
			this.item = {
				value: '',
				text: ''
			};
			this.listMerchantData1 = [{
				value: '',
				text: this.$t('common.selectMerchantPlaceHolder')
			}];
			this.totalRows = 0;
			this.orderStatus = status;
			this.pageNo = this.totalPage = 0;
			this.ponoFlt = '';
			this.searchchannel = '';
			//this.fromDateFlt = '';
			//this.toDateFlt = '';
			this.fromDateFltShip = '';
			this.toDateFltShip = '';
			this.ordertype = '';
			this.ordersubtype = '';
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
		},

		resetOrderSerach() {
			this.searchpickerid=''
			this.item = {
				value: '',
				text: ''
			};
			this.listMerchantData1 = [{
				value: '',
				text: this.$t('common.selectMerchantPlaceHolder')
			}];
			this.searchzone='';
			this.show = false;
			this.download = true;
			this.listOrderReportData = {
				ordercount: 0,
				totalsku: 0,
				totalquantity: 0,
				result: [],
			};
			this.totalRows = 0;

			this.pageNo = this.totalPage = 0;
			this.ponoFlt = '';
			document.getElementById("ponoFlt").value = "";
			this.searchchannel = '';
			this.fromDateFlt = '';
			this.toDateFlt = '';
			this.fromDateFltShip = '';
			this.toDateFltShip = '';
			this.ordertype = '';
			this.ordersubtype = '';
			// this.listMerchantData = [];
			this.merchant = ''
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
		},

		//validate all form fields on onsubmit()
		onSubmit: function () {
			this.$validator.validateAll().then(() => { }).catch(() => { });
		},
	} // end methods

}



// WEBPACK FOOTER //
// ./src/views/components/reports/orderreport/orderreport.component.js